import { TableSortOrder } from 'components/Table'
import Team from 'iam/models/Team'
import { computed, action, observable, makeObservable } from 'mobx'
import { orderBy } from 'lodash'
import PendingTeamMember from 'iam/models/PendingTeamMember'

export const pendingTeamMembersTableColumns: PendingTeamMemberTableColumns[] = [
  {
    header: 'Email',
    key: 'email',
    sortable: true,
  },
  {
    header: 'Invited On',
    key: 'dateCreated',
    sortable: true,
  },
  {
    header: 'Invite Expiration',
    key: 'expires',
    sortable: true,
  },
]

export type PendingTeamMemberTableColumns = {
  header: string
  key: 'email' | 'dateCreated' | 'expires'
  sortable?: boolean
}

export default class PendingTeamMembersViewModel {
  @observable sortOrder: TableSortOrder = 'none'
  @observable sortField: PendingTeamMemberTableColumns['key'] = 'email'

  constructor(
    public team: Team,
    private getPendingMembers: () => PendingTeamMember[],
    private getSearchText: () => string,
  ) {
    makeObservable(this)
  }

  @computed
  get pendingTeamMembers() {
    return this.getPendingMembers()
  }

  @computed
  get searchText() {
    return this.getSearchText()
  }

  @computed
  get currentSort() {
    return this.sortField
  }

  @computed
  get currentSortOrder() {
    return this.sortOrder
  }

  @computed
  get filtered() {
    let pendingMembers = this.pendingTeamMembers

    if (this.searchText !== '') {
      pendingMembers = this.pendingTeamMembers.filter((pendingMember) =>
        pendingMember.email
          .toLowerCase()
          .includes(this.searchText.toLowerCase()),
      )
    }

    return orderBy(
      pendingMembers,
      [this.sortField],
      this.sortOrder === 'none' ? undefined : this.sortOrder,
    )
  }

  @action.bound
  setSort(
    sortField: PendingTeamMemberTableColumns['key'],
    sortOrder: TableSortOrder,
  ) {
    this.sortField = sortField
    this.sortOrder = sortOrder
  }
}
